import { Component, OnInit, OnDestroy } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { Subscription, throwError } from 'rxjs';
import { UserCreateModel } from '../../auth/auth.models';
import { ActivatedRoute, Router } from '@angular/router';
import { map, catchError } from 'rxjs/operators';
import { AuthenticationService } from '../../services/auth/authentication.service';
import { ToastrService } from 'ngx-toastr';
import { UsersService } from '../../services/users/users.service';
import { ReportsService } from '../../services/reports/reports.service';

@Component({
  selector: 'app-create-user',
  templateUrl: './create-user.component.html',
  styleUrls: ['./create-user.component.scss']
})
export class CreateUserComponent implements OnInit, OnDestroy {
  public accountForm: FormGroup;
  public isLoading = false;
  public submitted = false;
  public onEdit: boolean;
  public userId: number;
  public passwordsequals: boolean = false;
  public values: any;
  public showArea: boolean;
  public role: string;

  private subs: Array<Subscription> = [];

  constructor(
    private formBuilder: FormBuilder,
    private router: Router,
    private userService: UsersService,
    private authService: AuthenticationService,
    private toastr: ToastrService,
    
    private activatedRoute: ActivatedRoute,
    private reportService: ReportsService,
  ) {
    
  }


  ngOnInit() {
    if (this.router.url === '/users/officers/create-officer') {
      this.showArea = true;
    }
    this.subs.push(
      this.activatedRoute.paramMap.subscribe((data: any) => {
        if (data.params.id) {
          this.userId = data.params.id;
          this.onEdit = true;
          this.userService.getUser(data.params.id)
            .subscribe(user => this.setValues(user));
            this.accountForm = this.formBuilder.group({
              firstName: ['', Validators.required],
              lastName: ['', Validators.required],
              phoneNumber: [''],
              email: ['', [Validators.required, Validators.pattern('(^[a-z0-9._%+-]+@[a-z0-9.-]+\\.[a-z]{2,4}$)|(^[0-9]{10}$)')]],
              password: ['', Validators.required],
              confirmedPassword: ['', [Validators.required]]
            })
        }
        else {
        this.onEdit = false;
          this.accountForm = this.formBuilder.group({
            firstName: ['', Validators.required],
            lastName: ['', Validators.required],
            phoneNumber: [''],
            email: ['', [Validators.required, Validators.pattern('(^[a-z0-9._%+-]+@[a-z0-9.-]+\\.[a-z]{2,4}$)|(^[0-9]{10}$)')]],
            password: ['', Validators.required],
            confirmedPassword: ['', [Validators.required]],
            area: ['']
          })
        }
      })
    );
    this.reportService
      .getValuestoCatalog('Departments')
      .subscribe(data => {
        this.values = data;
      });
  }

  ngOnDestroy(): void {
    this.subs.forEach((sub: Subscription) => sub.unsubscribe());
  }

  public get formState() {
    return this.accountForm.controls
  }

  private validatePasswords(): void {
    const password: string = this.accountForm.get('password').value;
    const confirmPassword: string = this.accountForm.get('confirmedPassword').value;

    if (password !== confirmPassword) {
      this.accountForm.controls['confirmedPassword'].setErrors({ incorrect: true });
    }
    else {
      this.passwordsequals = true;
    }
  }

  private setValues(user: any): void {
    const values = this.userService.mapRequiredValues(user);
    this.role = user.roles;
    console.log("roles",this.role)
    const { controls } = this.accountForm;

    for (const value in values) {
      if (controls.hasOwnProperty(value)) {
        this.accountForm.controls[value].setValue(values[value]);
      }
    }
  }

  private buildUser(): UserCreateModel {
    let url = this.router.url;
    if (url == '/users/admins/create-admin') {
      return {
        firstName: this.accountForm.controls['firstName'].value,
        lastName: this.accountForm.controls['lastName'].value,
        password: this.accountForm.controls['password'].value,
        email: this.accountForm.controls['email'].value,
        phoneNumber: this.accountForm.controls['phoneNumber'].value,
        roles: 'admin'
      }
    } if (url == '/users/supervisors/create-supervisor') {
      return {
        firstName: this.accountForm.controls['firstName'].value,
        lastName: this.accountForm.controls['lastName'].value,
        password: this.accountForm.controls['password'].value,
        email: this.accountForm.controls['email'].value,
        phoneNumber: this.accountForm.controls['phoneNumber'].value,
        roles: 'supervisor'
      }
    } if (url == '/users/officers/create-officer') {
      return {
        firstName: this.accountForm.controls['firstName'].value,
        lastName: this.accountForm.controls['lastName'].value,
        password: this.accountForm.controls['password'].value,
        email: this.accountForm.controls['email'].value,
        phoneNumber: this.accountForm.controls['phoneNumber'].value,
        roles: 'funcionario',
        area: this.accountForm.controls['area'].value
      }
    } if (url == '/users/neighborhood/create-neighborhood') {
      return {
        firstName: this.accountForm.controls['firstName'].value,
        lastName: this.accountForm.controls['lastName'].value,
        password: this.accountForm.controls['password'].value,
        email: this.accountForm.controls['email'].value,
        phoneNumber: this.accountForm.controls['phoneNumber'].value,
        roles: 'citizenhead',
        area: this.accountForm.controls['area'].value
      }
    }
  }

  private buildUserUpdate(): UserCreateModel {
    return {
      firstName: this.accountForm.controls['firstName'].value,
      lastName: this.accountForm.controls['lastName'].value,
      password: this.accountForm.controls['password'].value,
      email: this.accountForm.controls['email'].value,
      phoneNumber: this.accountForm.controls['phoneNumber'].value,
      roles: this.role
    }
  }

  private handleError({error}: any) {
    this.isLoading = false;
    this.toastr.error(error?.message || "Error no se pudo crear el usuario", 'Error', { timeOut: 2000 });
    return [];
  }

  onSubmit() {
    this.submitted = true;

    if (this.accountForm.invalid) {
      return;
    }

    this.validatePasswords();

    if (this.onEdit && this.passwordsequals) {
      this.editUser();
    }
    if (!this.onEdit && this.passwordsequals) {
      this.createUser();
    } 
    else {
      return;
    }

  }

  createUser() {
    const user: UserCreateModel = this.buildUser();
    this.isLoading = true;
    this.subs.push(
      this.authService.createUserPerson(user)
        .pipe(
          map(() => {
            let url = this.router.url;
            if (url == '/users/admins/create-admin') {
              this.handleUserCreation();
            } else if (url == '/users/supervisors/create-supervisor') {
              this.handleSupervisorCreation();
            }else if (url == '/users/neighborhood/create-neighborhood') {
              this.handleNeighborhoodCreation();
            } else {
              this.handleInterCreation();
            }
            setTimeout(() => {
              if (url == '/users/admins/create-admin') {
                this.router.navigateByUrl('users/admins');
              } else if (url == '/users/supervisors/create-supervisor') {
                this.router.navigateByUrl('users/supervisors');
              } else if (url == '/users/neighborhood/create-neighborhood') {
                this.router.navigateByUrl('users/neighborhood');
              } else {
                this.router.navigateByUrl('users/officers');
              }
            }, 1800);
          }),
          catchError(error => this.handleError(error))
        )
        .subscribe()
    );
  }

  editUser() {
    const user: UserCreateModel = this.buildUserUpdate();
    this.isLoading = true;
    this.subs.push(
      this.authService.editUserPerson(user, this.userId)
        .pipe(
          map(() => {
              this.handleUserEdit();
            setTimeout(() => {
              console.log(this.role);
              if (this.role === 'admin') {
                this.router.navigateByUrl('users/admins');
              }else if (this.role === 'supervisor') {
                this.router.navigateByUrl('users/supervisors');
              }else if (this.role == 'citizenhead') {
         
                this.router.navigateByUrl('users/neighborhood');
              }else if (this.role === 'funcionario') {
                this.router.navigateByUrl('users/officers');
              } else {
                this.router.navigateByUrl('users');
              }
            }, 1800);
          }),
          catchError(error => this.handleError(error))
        )
        .subscribe()
    );
  }

  private handleUserCreation() {
    this.toastr.success('Administrador creado correctamente', 'Administrador', { timeOut: 1700 });
  }

  private handleInterCreation() {
    this.toastr.success('Funcionario creado correctamente', 'Funcionario', { timeOut: 1700 });
  }

  private handleSupervisorCreation() {
    this.toastr.success('Supervisor creado correctamente', 'Supervisor', { timeOut: 1700 });
  }

  private handleNeighborhoodCreation() {
    this.toastr.success('Jefe de manzana creado correctamente', 'Jefe de manzana', { timeOut: 1700 });
  }

  private handleUserEdit() {
    this.toastr.success('Usuario actualizado correctamente', 'Usuario', { timeOut: 1700 });
  }

}
